import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Card, Form, Button, Spinner, Container, Navbar, Nav, InputGroup, Alert} from 'react-bootstrap';
import Swal from 'sweetalert2';
import ReactMarkdown from 'react-markdown';
import RenderizarProduto from '../Utils/RenderizarProduto';
import RenderizarFoto from '../Utils/RenderizarFoto';
import ImageCropper from '../Utils/ImageCropper';
import BotaoSacola from './BotaoSacola';
import AOS from "aos";
import 'aos/dist/aos.css';

const Produtos = ({crud, Toast, empresa, storage, queryParams}) => {
    const navigate = useNavigate();
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [produtos, setProdutos] = useState([]); // Produtos carregados
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    
    const { get, post, loading } = crud;  // Obtendo os métodos do hook useCrud
    
    useEffect(() => {
        // Inicialize o AOS para as animações, caso esteja usando isso
        AOS.init({
          duration: 1000,
          easing: "ease-in-out",
          once: true,
          mirror: false
        });
      }, []);

    // Função para buscar produtos na API
    const buscarProdutos = async (novaBusca = false) => {
        let url = `/gvendas/produtos/?is_catalogo=true&ordering=categoria__ordem,nome_do_produto&empresa=${empresa?.id}&expand=categoria`;

        if (query) url += `&search=${query}`;

        if (novaBusca) {
            setProdutos([]); // Limpa os produtos anteriores
            setNextUrl(null); // Reseta o nextUrl
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url, 'pagina', false);
          if(response){
            const novosProdutos = response[0].results; // Corrigir para acessar o resultado correto
            setProdutos((produtosAnteriores) => novaBusca ? novosProdutos : [...produtosAnteriores, ...novosProdutos]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar produtos"
          // });
        }finally{
          
        }
    };

    // Carrega os produtos ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      if (empresa?.id){
        buscarProdutos(true); // Sempre faz uma nova busca
      }
    }, [query, empresa?.id]);
    
    // Detecta o fim da página para carregar mais produtos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutos();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const produtosAgrupadas = produtos.reduce((acc, produto) => {
      const grupo = produto.categoria?.ordem || ''; // Assumindo que data_da_venda está no formato desejado
      if (!acc[grupo]) {
        acc[grupo] = {
          categoria : produto.categoria,
          lista : []
        }
      }
      acc[grupo].lista.push(produto);
      return acc;
    }, {});
    
    const carrinho = () => {
      navigate(`?p=checkout`)
    }
    
    const botao = {
      onClick:carrinho, 
      text:'Prosseguir'
    }
    
    const venda = {
      quantidade:1,
      desconto:0,
      total:344
    }
    
    return (
        <>
          <BotaoSacola botao={botao} empresa={empresa} storage={storage}/>
          <div className="mt-3" data-aos="fade-up">
            <Form>
              <Form.Group controlId="formBasicSearch">
                <div className="input-group">
                  <Form.Control 
                      type="text" 
                      placeholder="Digite o nome do produto" 
                      value={query} 
                      onChange={(e) => setQuery(e.target.value)} 
                  />
                  <Button variant="secondary" onClick={() => buscarProdutos(true)}>
                      <i className="bi bi-search"></i>
                  </Button>
                </div>
              </Form.Group>
            </Form>
                <div className="list-group mt-3">
                    {Object.entries(produtosAgrupadas).length > 0 ? (
                      Object.entries(produtosAgrupadas).map(([grupo, item]) => (
                        <div key={grupo}>
                          <div className="text-muted mt-2">{item.categoria.nome_da_categoria}</div>
                          {item.lista.map((x) => (
                            <RenderizarProduto
                              key={x.id}
                              onClick={()=>navigate(`?p=adicionar-produto&id=${x.id}`)}
                              src={x.foto_do_produto}
                              text1={x.nome_do_produto}
                              titulo={parseFloat(x.preco_unitario).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              text2={!empresa?`Por ${x.empresa?.nome_da_loja}`:''}
                            />
                          ))}
                        </div>
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarProdutos(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

export default Produtos